import {Locale} from '../../provider/locale/locale';
import {LangKeyType} from '../../provider/locale/translation/type';
import {classNames} from '../../util/css';

import * as styles from './error-data.scss';

type PropsType = {
    langKey: LangKeyType;
    className?: string;
};

export function ErrorData(props: PropsType): JSX.Element {
    const {langKey, className} = props;

    return (
        <div className={classNames(styles.error_data, className)}>
            <p className={styles.error_data__text}>
                <Locale stringKey={langKey} />
            </p>
        </div>
    );
}
